// Todos os profissionais de saúde e AD01
//Com vínculo homologado

import { getItemDecrypt } from "./cryptoData";

//

const routerProfessionalHomolog = [
  "/home",
  "/pacientes",
  "/agendamentos",
  "/agendamentos",
  "/agendamentos/novo-agendamento",
];

//Com perfil de administrador ou status administrador
const routerAdmin = [
  "/gerenciamento-sistema",
  "/gerenciamento-sistema/gerenciamento-usuarios",
];

///acesso concedido pelo paciente
const routerPermissionAcesse = [
  "/pacientes/prontuario",
  "/pacientes/resumo-consulta",
  "/escalas",
  "/paciente/monitoramento/anjo",
];

// Neurologista
const routerNeurologist = [
  "/pacientes/primeira-consulta",
  "/pacientes/consulta-rotina",
  "/pacientes/primeira-avaliacao",
];

const routerHealth = ["/pacientes/consulta-demais-profissionais"];

const routerRequerdVinculoActive = [
  ...routerProfessionalHomolog,
  ...routerAdmin,
  ...routerPermissionAcesse,
  ...routerNeurologist,
  ...routerHealth,
];

//// modulo paciente apenas paciente
const routerModulePatient = [
  "/paciente/home",
  "/paciente/geracesso",
  "/paciente/escalaspaciente",
];

export function permissionRoutes(pathname) {
  return new Promise((resolve) => {
    let usuario = getItemDecrypt("usuario");
    let vinculo = getItemDecrypt("vinculo_ativo");
    let paciente = getItemDecrypt("paciente");

    if (pathname === "/vinculos") {
      resolve({
        hasPermission: usuario && !paciente,
        path: "/login",
      });
      return;
    }

    if (routerModulePatient.includes(pathname)) {
      resolve({
        hasPermission: !!paciente,
        path: "/pacienteLogin",
      });
      return;
    }

    if (routerRequerdVinculoActive.includes(pathname.replace(/\/\d+$/, ""))) {
      if (!vinculo) {
        resolve({
          hasPermission: false,
          path: `/vinculos`,
        });
        return;
      }

      if (routerProfessionalHomolog.includes(pathname)) {
        resolve({
          hasPermission: true,
          path: `/vinculos`,
        });
        return;
      }

      if (routerAdmin.includes(pathname)) {
        if (vinculo.administrador || vinculo.perfil.id === 1) {
          resolve({
            hasPermission: vinculo.administrador || vinculo.perfil.id === 1,
            path: "/home",
          });
          return;
        }
      }
      if (routerNeurologist.includes(pathname.replace(/\/\d+$/, ""))) {
        resolve({
          hasPermission: vinculo.perfil.id === 4,
          path: "/home",
        });
        return;
      }

      if (routerHealth.includes(pathname.replace(/\/\d+$/, ""))) {
        resolve({
          hasPermission: vinculo.perfil.id !== 4 && vinculo.perfil.id !== 1,
          path: "/home",
        });
        return;
      }
      if (routerPermissionAcesse.includes(pathname.replace(/\/\d+$/, ""))) {
        resolve({
          hasPermission: true,
          path: "/home",
        });
        return;
      }
    }

    resolve({
      hasPermission: true,
      path: `/`,
    });
  });
}
